import React from 'react'

interface Props {
    onClose: () => void;
    onDone: () => void;
    newFolderName?: any;
    setNewFolderName?: any
}

const AddFolder = ({ onClose, onDone, newFolderName, setNewFolderName }: Props) => {
    return (
        <>
            {/* Backdrop */}
            <div className="cl-backdrop" />

            {/* Drawer panel */}
            <div className="cl-drawer">

                {/* Header */}
                <div className="cl-drawer__header">
                    <button className="cl-drawer__close" onClick={onClose}>
                        <img src='/assets/images/dismiss.svg' alt='close' />
                    </button>
                    <h2 className="cl-drawer__title">Create Folder</h2>
                </div>

                {/* Step content */}
                <div className="cl-drawer__body">
                    <div className="cl-step">
                        <div className="cl-step__fields">
                            <div className="input-field-wrapper">
                                <div className="input-field-label-row">
                                    <label className="input-field-label">Folder Name</label>
                                </div>
                                <div className="input-field-box">
                                    <input
                                        className="input-field-input"
                                        type="text"
                                        placeholder="Enter folder name"
                                        value={newFolderName}
                                        onChange={e => setNewFolderName(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cl-drawer__footer">
                    <div className="cl-dots"></div>
                    <button className="cl-btn-next" onClick={onDone}>Create Folder</button>
                </div>
            </div>
        </>
    )
}

export default AddFolder